import { type ValidationRule } from '../../types';

import { CanonicalStepRuleBase } from './base';

class PushModeRule extends CanonicalStepRuleBase {
  public constructor() {
    super('steps.PushMode', 'PushMode');
  }

  protected validate(): void {
    // No-op
  }
}

export const PushModeValidation: ValidationRule =
  new PushModeRule().toValidationRule();
